import { Box, Divider, Typography } from "@mui/material";
import { useAtom } from "jotai";
import {
  DEFAULT_SLIM_WIDTH,
  DEFAULT_WIDTH,
  rightPanelExpanded,
} from "../../../components/layout/dashboard/RightPanel";
import { ProcessExecution } from "../../../model/ProcessExecution";
import { AssignedRoleUserDto } from "../../../types";
import ProcessExecutionUpdated from "./ProcessExecutionStarted";
import ProcessPhaseChip from "./ProcessPhaseChip";
import ProcessProgress from "./ProcessProgress";
import { ProcessExecutionDetailTabs } from "./execution";
import { SideDetailsSection } from "./side-details";
import SideDetailsContainer from "./side-details/SideDetailsContainer";

export const ProcessExecutionSidePanel = ({
  organizationId,
  processExecution,
  attachmentReloadTrigger,
  assignedRoleUsers,
}: {
  organizationId?: string;
  processExecution?: ProcessExecution;
  attachmentReloadTrigger: number;
  assignedRoleUsers: AssignedRoleUserDto[];
}) => {
  const [expanded] = useAtom(rightPanelExpanded);

  return (
    <Box display={"flex"}>
      <SideDetailsContainer
        scrollable={true}
        sx={{
          display: "flex",
          flexDirection: "column",
          width: expanded ? DEFAULT_WIDTH : DEFAULT_SLIM_WIDTH,
          transition: "width 0.2s ease-in-out",
        }}
      >
        <SideDetailsSection sx={{ display: "flex", gap: 3 }}>
          <Box sx={{ flex: 0 }}>
            {processExecution && <ProcessPhaseChip {...processExecution} />}
          </Box>
          <Box sx={{ flexBasis: "auto" }}>
            {processExecution && (
              <ProcessExecutionUpdated {...processExecution} />
            )}
          </Box>
        </SideDetailsSection>
        <Divider />
        <SideDetailsSection
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: 24 }}>
            Progress:
          </Typography>
          <Box sx={{ flexBasis: "auto", minWidth: "200px" }}>
            {processExecution && (
              <ProcessProgress processExecution={processExecution} />
            )}
          </Box>
        </SideDetailsSection>
        {/* TODO: Make dynamic with data and redesign */}
        <SideDetailsSection>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            {/* <TaskExecutionTracker processExecution={processExecution} /> */}
            {/* Overlay icons on top of LinearProgress */}
          </Box>
        </SideDetailsSection>
        <Divider />
        {processExecution && organizationId && (
          <ProcessExecutionDetailTabs
            processExecution={processExecution}
            organizationId={organizationId}
            attachmentReloadTrigger={attachmentReloadTrigger}
            assignedRoleUsers={assignedRoleUsers}
          />
        )}
      </SideDetailsContainer>
    </Box>
  );
};
